<template>
  <el-config-provider :locale="locale">
    <!-- loading -->
    <loading v-if="store.getGlobalState('loading')" />
    <!---登录和主页等没有layout--->
    <router-view v-if="!showLayout" />
    <layout v-show="showLayout" />
  </el-config-provider>
</template>

<script setup>
import {ref, watch, computed, onBeforeMount, onMounted} from "vue";
import { useRouter, useRoute } from "vue-router";
import i18n from '@/language';
import zh from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import loading from './pages/loading.vue'
import layout from "./layout"
import store from "@/store";
import { utils } from 'common';

const route = useRoute();
const showLayout = ref(false);

let locale = computed(() => (store.getGlobalState('language') === 'zh' ? zh : en))
i18n.global.locale = store.getGlobalState('language')

// 监测路由判断是主应用路由还是子应用路由
watch(
  () => route.path,
  () => {
    if (['/login', '/', '/print/index'].includes(route.path)) {
      showLayout.value = false
    } else {
      showLayout.value = true
    }
  },
  {
    immediate: true
  }
)

onBeforeMount(()=>{
  if(utils.storage.ss.get('store')){
    store.setGlobalState(utils.storage.ss.get('store'))
    locale = computed(() => (store.getGlobalState('language') === 'zh' ? zh : en))
    i18n.global.locale = store.getGlobalState('language')
  }
})

onMounted(()=>{
  // 在页面刷新时将store保存到sessionStorage里
  window.addEventListener('beforeunload', () => {
    utils.storage.ss.set('store', store.getGlobalState())
  })

  // 打印时隐藏部分元素
  window.addEventListener("beforeprint", ()=>{
    showLayout.value = false
  })
  // 打印完成显示
  window.addEventListener("afterprint", ()=>{
    showLayout.value = true
  })
})
</script>

<style lang="scss">
#main-app{
  width: 100%;
  height: 100%;
  min-width: 1280px;
  min-height: 800px;
  position: relative;
  color: #2c3e50;
}
div[data-name="sub-team"], div[data-name="sub-report"]{
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
